import api from './api';
import { toast } from 'react-toastify';
import {
  COLUMNS_CONSULTA_PROPOSTA,
  COLUMNS_EXCLUSAO_PROPOSTA,
  COLUMNS_REANALISE_EXCLUSAO,
  COLUMNS_IMPRESSAO_DOCS,
} from '../constants/mocks';
import tipoCombustivel from '../constants/tipoCombustivel';
import { getEstados, getCidades } from './cep';
import MaskCPFandCNPJ from '../util/maskCPFandCNPJ';

const enviarParaAnalise = async (idProposta) => {
  try {
    const client = await api('mesaveic');
    const {data} = await client.get(`proposta/enviarParaAnalise?idContrato=${idProposta}`);
    
    if(data === true){
      toast.success('Proposta enviada para análise de pagamento com sucesso!')
      setTimeout( () => {
        window.location.reload();
      }, 2000);
    }else {
      toast.error('Não foi possível enviar a proposta para Análise de Pagamento')
    }
  } catch (error) {
    console.log(error);
    toast.error('Não foi possível enviar a proposta para Análise de Pagamento')
    return [];
  }
}

const desbloqueiaPropostaUpload = async (idProposta) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post(`bloqueioContrato/liberar?idContrato=${idProposta}&tipo=Upload`);
    return data ? data : [];
  } catch (error) {
    return [];
  }
};

const bloqueiaPropostaUpload = async (idProposta) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get(`bloqueioContrato?idContrato=${idProposta}&tipo=Upload`);
    return data ? data : [];
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar verificar se esse processo já está em andamento'
    );
  }
};

const salvarObsReanaliseExclusao = async (value) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post(
      `proposta/salvarObsReanaliseExclusao`,
      value
    );
    return data ? data : [];
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar solicitar a reanálise.');
  }
};

const getColumnsImpressaoDocs = async () => {
  try {
    return COLUMNS_IMPRESSAO_DOCS;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar as colunas.');
  }
};

const getDocsImpressaoDocs = async (id, docs) => {
  try {
    toast.success('Aguarde. Estamos preparando os arquivos para download');
    const client = await api('mesaveic');
    const {
      data,
    } = await client.get(
      `/documentosAssinatura/download/${id}?docs=${docs.join(',')}`,
      { responseType: 'arraybuffer' }
    );

    return data ? data : [];
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar baixar os documentos.');
  }
};

const getListImpressaoDocs = async (values) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get(`/documentosAssinatura/listar/${values}`);

    return data ? data : [];
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os documentos.');
  }
};

const getColumnsReanaliseExclusao = async () => {
  try {
    return COLUMNS_REANALISE_EXCLUSAO;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar as colunas.');
  }
};

const getListReanaliseExclusao = async (idProposta) => {
  try {
    let value = { idProposta: idProposta };
    const client = await api('mesaveic');
    const { data } = await client.post(`proposta/reanaliseExclusao`, value);

    return data ? data.obj : [];
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar as informações.');
  }
};

const getFilters = async () => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get(`proposta/filtroCampos`);

    data.fields.map((f) => {
      if (f.name === 'funcionalidade') {
        f.afterChange = (e) => {
          data.fields.map(
            (df) => df.name === 'statusSecundario' && (df.disabled = false)
          );
          if (e === 'solicitacaoPagamento') {
            data.fields.map(
              (df) =>
                df.name === 'statusSecundario' &&
                (df.remote = {
                  method: 'GET',
                  service: 'consulta',
                  path: `/filtros/status/secundario/${e}`,
                })
            );
          } else if (e === 'exclusaoProposta') {
            data.fields.map(
              (df) =>
                df.name === 'statusSecundario' &&
                (df.remote = {
                  method: 'GET',
                  service: 'consulta',
                  path: `/filtros/status/secundario/${e}`,
                })
            );
          } else if (e === 'ponte') {
            data.fields.map(
              (df) =>
                df.name === 'statusSecundario' &&
                (df.remote = {
                  method: 'GET',
                  service: 'consulta',
                  path: `/filtros/status/secundario/${e}`,
                })
            );
          }
        };
      }
    });

    return data.fields ? data.fields : [];
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os filtros.');
    return null;
  }
};

const getColumns = () => {
  try {
    /*
        const client = await api('consulta');
        const { data } = await client.get(`${type}/columns`);
        */

    return COLUMNS_CONSULTA_PROPOSTA;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os filtros.');
    return null;
  }
};

const getList = async (values) => {
  try {
    const client = await api('consulta');
    const response = await client.post('/consulta', values);
    return response.data ? response.data : [];
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os dados.');
    return [];
  }
};

const getLogsPropostaAnalise = async (idLocalizador) => {
  try {
    const client = await api('corporate');
    const { data } = await client.get(
      `/auditoria/getLogResumidoSmart/?localizador=${idLocalizador}`
    );

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os Logs.');
    return null;
  }
};

const getLogsStatusFuncionalidades = async (idLocalizador) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get(`/statusFuncionalidade/${idLocalizador}`);

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os Logs.');
    return null;
  }
};

const getLogsProposta = async (idLocalizador, IdMenu) => {
  try {
    const client = await api('corporate');
    let { data } = await client.get(
      `/auditoria/getLogsAuditoria/?localizador=${idLocalizador}${!!IdMenu ? '&IdMenu=' + IdMenu : ''}`,
    );

    if (typeof data === 'string') {
      data = [];
    }

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os Logs.');
    return null;
  }
};

const getExcelLogs = async (idLocalizador, title) => {
  try {
    const client = await api('corporate');
    let {
      data,
    } = await client.get(
      `/auditoria/getExcelLogsAuditoria/?localizador=${idLocalizador}&title=${title}`,
      { responseType: 'arraybuffer' }
    );

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os Logs.');
    return null;
  }
};

const getExcelDocumentosPendentes = async (idLocalizador) => {
  try {
    const client = await api('consulta');
    let { data } = await client.get(
      `contrato/criterios?aprova=0&modal=true&excel=true&idContrato=${idLocalizador}`
    );

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os Logs.');
    return null;
  }
};

const getDocumentosPendentes = async (idLocalizador) => {
  try {
    const client = await api('consulta');
    let { data } = await client.get(
      `contrato/criterios?aprova=0&modal=true&idContrato=${idLocalizador}`
    );

    if (typeof data === 'string') {
      data = [];
    }

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os Documentos Pendentes.');
    return null;
  }
};

const getHistoricoProposta = async (idLocalizador) => {
  try {
    const client = await api('corporate');
    const { data } = await client.get(
      `/auditoria/getAuditoriaResumoSmart/?localizador=${idLocalizador}`
    );

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os Logs.');
    return null;
  }
};

const getHistoricoContrato = async (idLocalizador) => {
  try {
    const client = await api('corporate');
    console.log("IdLocat", idLocalizador)
    const { data } = await client.get(
      `/auditoria/getAuditoriaResumoSmart/?localizador=${idLocalizador}`
    );

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os Logs.');
    return null;
  }
};

const getDocuments = async (idContrato, IdMenu) => {
  try {
    const client = await api('consulta');
    const { data } = await client.get(
      `/contrato/documentos?idContrato=${idContrato}${!!IdMenu ? '&IdMenu=' + IdMenu : ''}`
    );

    const ret = data
      ? data.documentos.map((element) => {
        return {
          path: element.imagemPath,
          alt:
            element.dados && element.dados[0] ? element.dados[0].value : '',
          tipoCaptura:
            element.dados && element.dados[1] ? element.dados[1].value : '',
          pagina:
            element.dados && element.dados[2] ? element.dados[2].value : '',
          dataCaptura:
            element.dados && element.dados[3] ? element.dados[3].value : '',
          idDocumento: element.idDocumento,
        };
      })
      : [];

    return ret;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar as imagens.');
    return null;
  }
};

const getTabsData = async () => {
  try {
    const client = await api('consulta');
    const { data } = await client.get(`/contrato/tabs`);

    if (data && data.error) {
      toast.error(data.error);
      return [];
    }

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os dados das tabs.');
    return null;
  }
};

const saveSolicitacaoPonte = async (dataSend) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post(`/solicitacaoPonte/gravar`, dataSend);

    if (data.success && data.msg) {
      toast.success(data.msg);
    }

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar gravar os dados de ponte.');
    return null;
  }
};

const setTipoDocumento = async (tipoDoc, idDoc) => {
  try {
    let body = {
      idDocumento: idDoc,
      idTipoDocto: tipoDoc,
    };

    const client = await api('consulta');
    const { data } = await client.post('/contrato/tipificacao', body);
    if(data.alteraFila) window.location.reload();
    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar editar o tipo de documento.');
    return null;
  }
};

const solicitarReassinatura = async (dados) => {
  try {
    if (!dados.observacao) dados.observacao = '';

    const client = await api('mesaveic');
    const { data } = await client.post('/grafometria', dados);

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar solicitar a reassinatura.');
    return null;
  }
};

const getButtonActions = async (idProposta, origem) => {
  try {
    if (!idProposta) {
      return null;
    }
    const client = await api('consulta');
    const { data } = await client.get(
      `/contrato/acaoBotao?idContrato=${idProposta}&origem=${origem}`
    );

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar consultar as ações disponiveis.');
    return null;
  }
};

const getButtonActionsAnalise = async (idProposta) => {
  try {
    if (!idProposta) {
      return null;
    }
    const client = await api('consulta');
    const { data } = await client.get(
      `/contrato/acaoBotaoAnalise?idContrato=${idProposta}`
    );

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar consultar as ações disponiveis.');
    return null;
  }
};

const getDadosProposta = async (idContrato) => {
  try {
    const client = await api('consulta');
    const { data } = await client.get(`/contrato?idContrato=${idContrato}`);

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os dados da proposta.');
    return null;
  }
};

const getTimeoutAtualizacaoFila = async () => {
  try {
    const client = await api('consulta');
    const { data } = await client.get('/parametro/TempoAtualizacaoFila');

    return data;
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar carregar o tempo de atualização da proposta.'
    );
    return null;
  }
};

const getStatusFila = async (idContrato) => {
  try {
    const client = await api('consulta');
    const { data } = await client.get(`/contrato/statusFila/${idContrato}`);

    return { idFila: data.IdFila, msgFilaErro: data.MsgFilaErro };
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar o status da proposta.');
    return null;
  }
};

const getDadosPropostaPonte = async (id) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get(`/solicitacaoPonte/carregar/${id}`);

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os dados da proposta.');
    return null;
  }
};

const recadastrarSolicitacaoPonte = async (dataSend) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post(
      `/solicitacaoPonte/recadastrar`,
      dataSend
    );

    if (data.success && data.msg) {
      toast.success(data.msg);
    }

    return data;
  } catch (error) {
    toast.error('Não foi possível recadastrar ponte.');
    return null;
  }
};

const getEstadoCidade = async (dados) => {
  let ufs = await getEstados();
  let uf = '';
  let cidade = '';

  if (ufs) {
    if (dados.estado)
      uf = ufs.find((estado) => estado.value === dados.estado.toUpperCase());

    if (uf) {
      uf = uf.value;
      let cidades = await getCidades(uf);

      if (dados.municipioPlacaVeiculo)
        cidade = cidades.find(
          (c) =>
            c.value.toUpperCase() === dados.municipioPlacaVeiculo.toUpperCase()
        );

      if (!cidade && dados.cidadeAutomovel)
        cidade = cidades.find(
          (c) => c.value.toUpperCase() === dados.cidadeAutomovel.toUpperCase()
        );

      cidade = cidade ? cidade.value : '';
    } else uf = '';
  }

  return { uf, cidade };
};

const getDadosPropostaVeiculo = async (idContrato) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get(
      `/contrato/veiculo?idContrato=${idContrato}`
    );

    if (data) {
      let { uf, cidade } = await getEstadoCidade(data);

      data.estado = uf;
      data.municipio = data.cidadeVeiculosPag || cidade;

      if (data.cnpjLoja) data.cnpjLoja = MaskCPFandCNPJ(data.cnpjLoja);

      if (data.tipoCombustivel) {
        var tpComb = '';
        tipoCombustivel.forEach((item) => {
          if (item.value.toUpperCase() === data.tipoCombustivel.toUpperCase()) {
            tpComb = item.value;
          }
        });
      }
      data.idContrato = idContrato;
      data.tipoCombustivel = tpComb;
    }

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os dados de veiculo.');
    return null;
  }
};

const getDadosChecagemLTLR = async (idContrato) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get(
      `/contrato/ltlr?idContrato=${idContrato}`
    );

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar as informações.');
    return null;
  }
};

const saveDadosChecagemLTLR = async (idContrato, dados, finalizar) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post(
      `/contrato/ltlr?idContrato=${idContrato}`,
      {
        dados,
        finalizar,
      }
    );

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar salvar as informações.');
    return null;
  }
};

const gravarFormAvaliacao = async (dataSend) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post(
      `/contrato/formavaliacao/gravar`,
      dataSend
    );

    if (data.success && data.msg) {
      toast.success(data.msg);
    }

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar enviar os dados de avaliação.');
    return null;
  }
};

const carregarUrlComprovante = async (idContrato) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get(
      `solicitacaoPagamento/comprovante?idContrato=${idContrato}`
    );
    return data;
  } catch (error) {
    return null;
  }
};

const getJsonCarga = async (IdCargaPreProcessamento) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get(
      `auditoria/jsoncarga/${IdCargaPreProcessamento}`
    );
    return data;
  } catch (error) {
    return null;
  }
};

const verificarAlertaPendencia = async (idContrato) => {
  try {
    const client = await api('consulta');
    const { data } = await client.get(`consulta/alertaPendencia/${idContrato}`);
    return data;
  } catch (error) {
    return null;
  }
};

const verificarAlertaPreExclusao = async (idContrato) => {
  try {
    const client = await api('consulta');
    const { data } = await client.get(
      `consulta/alertaPreExclusao/${idContrato}`
    );
    return data;
  } catch (error) {
    return null;
  }
};

const carregarAnaliticoDash = async (idsContrato) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post('/relatorio/prePag/dadosContrato', {
      idsContrato,
    });
    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar as informações.');
    return null;
  }
};

const exportExcelAnalitico = async (idsContrato) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post(
      '/relatorio/prePag/exportarExcel',
      { idsContrato },
      { responseType: 'arraybuffer' }
    );
    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar as informações.');
    return null;
  }
};

const getColumnsExclusao = () => {
  try {
    return COLUMNS_EXCLUSAO_PROPOSTA;
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar carregar as colunas da exclusão da proposta.'
    );
    return null;
  }
};

const getDocumentosExclusao = async (idContrato) => {
  try {
    if (!idContrato) {
      return [];
    }

    const client = await api('mesaveic');
    const { data } = await client.get(
      `/pendencias/carregarDocumentos/?IdContrato=${idContrato}`
    );

    if (!data || !data.success || !data.obj) {
      return [];
    }

    return data.obj;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os documentos');
    return null;
  }
};
const getMotivosExclusao = async (idCriterio, IdContrato) => {
  try {
    if (!idCriterio) {
      return [];
    }

    const client = await api('mesaveic');
    const { data } = await client.get(
      `pendencias/carregarMotivos?IdCriterio=${idCriterio}&IdContrato=${IdContrato}`
    );

    if (!data || !data.success || !data.obj) {
      return [];
    }

    return data.obj;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os Motivos');
    return null;
  }
};

const excluirProposta = async (dataSend) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post('/proposta/excluir', dataSend);

    if (data.success && data.msg) {
      toast.success(data.msg);
    }

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar excluir a proposta');
    return null;
  }
};

const exportPDFAnalitico = async (idsContrato) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post(
      '/relatorio/prePag/exportarPDF',
      { idsContrato },
      { responseType: 'arraybuffer' }
    );
    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar as informações.');
    return null;
  }
};
const verificarSolicitacaoPagamento = async (numProposta) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get(
      `/solicitacaoPagamento/verificarSolicitacao`,
      {
        headers: {
          numProposta: numProposta,
        },
      }
    );
    if (data && data.success && !data.podeSolicitar) {
      toast.error(data.msg);
    }
    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar as informações.');
    return null;
  }
};

const getResumoProposta = async (idContrato, IdMenu = undefined) => {
  try {
    const client = await api('consulta');
    const { data } = await client.get(
      `/resumo/dados`,
      {
        params: {
          idContrato,
          ...(IdMenu && { IdMenu })
        }
      }
    );
    if (data && data.success && !data.podeSolicitar) {
      toast.error(data.msg);
    }
    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar as informações.');
    return null;
  }
}


const getProposta = async (numProposta) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.getProposta(
      `/proposta/numproposta`,
      {
        params: {
          numProposta,
        }
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
}

const postPropostaServiceDesk = async (body) => {
  try {
    const client = await api('servicedesk');
    const { data } = await client.post(`/proposta`, body);
    if (data && data.success && !data.podeSolicitar) {
      toast.warn(data.msg);
    }
    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar salvar os dados.');
    return null;
  }
}
export {
  getFilters,
  getColumns,
  getList,
  getHistoricoProposta,
  getHistoricoContrato,
  getLogsProposta,
  getExcelLogs,
  getLogsPropostaAnalise,
  getLogsStatusFuncionalidades,
  getDocuments,
  getTabsData,
  setTipoDocumento,
  saveSolicitacaoPonte,
  getButtonActions,
  getButtonActionsAnalise,
  solicitarReassinatura,
  getDadosProposta,
  getDadosPropostaPonte,
  getDadosChecagemLTLR,
  saveDadosChecagemLTLR,
  getDadosPropostaVeiculo,
  gravarFormAvaliacao,
  carregarUrlComprovante,
  getTimeoutAtualizacaoFila,
  getStatusFila,
  recadastrarSolicitacaoPonte,
  getDocumentosPendentes,
  getExcelDocumentosPendentes,
  getJsonCarga,
  carregarAnaliticoDash,
  exportExcelAnalitico,
  getColumnsExclusao,
  getDocumentosExclusao,
  getMotivosExclusao,
  excluirProposta,
  exportPDFAnalitico,
  verificarAlertaPendencia,
  verificarAlertaPreExclusao,
  getListReanaliseExclusao,
  getColumnsReanaliseExclusao,
  salvarObsReanaliseExclusao,
  getColumnsImpressaoDocs,
  getListImpressaoDocs,
  getDocsImpressaoDocs,
  bloqueiaPropostaUpload,
  desbloqueiaPropostaUpload,
  verificarSolicitacaoPagamento,
  enviarParaAnalise,
  getResumoProposta,
  getProposta,
  postPropostaServiceDesk
};
